@if (type === 'card') {
  <div class="skeleton-card-container">
    @for (i of getArrayFromNumber(); track $index) {
      <div class="skeleton-card pulse">
        <div class="skeleton-card-header shimmer"></div>
        <div class="skeleton-card-body shimmer"></div>
      </div>
    }
  </div>
}

@if (type === 'table') {
  <div class="skeleton-table-container">
    <div class="skeleton-table">
      <span class="skeleton-table-header">
        @for (data of placeHolderData; track data) {
          <span
          class="skeleton-table-header-item">{{data}}</span>
        }
      </span>
      @for (i of getArrayFromNumber(); track $index) {
        <div class="skeleton-table-item pulse">
          @for (data of placeHolderDataContent; track data) {
            <span class="skeleton-table-data shimmer">
              <div [style.width]="data.width" class="content shimmer"></div>
            </span>
          }
        </div>
      }
    </div>
  </div>
}
